import { Component } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

export interface AddNoteModalModel {
  entityType: 'citation' | 'appeal';
  entityId: number;
  entityReference?: string;
}

export interface AddNoteModalResult {
  content: string;
}

@Component({
    selector: 'app-add-note-modal',
    template: `
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <span class="icon mr-2"><i class="fas fa-sticky-note"></i></span>
            Add Note to {{entityType === 'citation' ? 'Citation' : 'Appeal'}}{{entityReference ? ' #' + entityReference : ''}}
          </p>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Note <span class="has-text-danger">*</span></label>
            <div class="control">
              <textarea
                class="textarea"
                [(ngModel)]="noteContent"
                placeholder="Enter your note here..."
                rows="6"
                maxlength="2048">
              </textarea>
            </div>
            <p class="help">
              <span [class.has-text-danger]="noteContent.length > 2000">
                {{noteContent.length}}/2048 characters
              </span>
              @if (noteContent.length > 2000) {
                <span class="ml-2 has-text-danger">
                  Approaching limit!
                </span>
              }
            </p>
            <p class="help has-text-grey">
              <span class="icon is-small"><i class="fas fa-info-circle"></i></span>
              Notes are permanent records and cannot be deleted.
            </p>
          </div>
        </section>
        <footer class="modal-card-foot">
          <div class="buttons is-right" style="width: 100%;">
            <button class="button" (click)="close()">Cancel</button>
            <button class="button is-primary" (click)="confirm()" [disabled]="!canConfirm()">
              <span class="icon"><i class="fas fa-plus"></i></span>
              <span>Add Note</span>
            </button>
          </div>
        </footer>
      </div>
    </div>
    `,
    styles: [`
    .modal-card {
      max-width: 600px;
      width: 90%;
    }
    .modal-card-body {
      padding: 1.5rem;
    }
    .textarea {
      resize: vertical;
      min-height: 150px;
    }
  `],
    standalone: false
})
export class AddNoteModalComponent extends SimpleModalComponent<AddNoteModalModel, AddNoteModalResult> {
  entityType: 'citation' | 'appeal' = 'citation';
  entityId: number = 0;
  entityReference?: string;
  
  noteContent: string = '';

  constructor() {
    super();
  }

  canConfirm(): boolean {
    return this.noteContent.trim().length > 0 && this.noteContent.length <= 2048;
  }

  confirm() {
    if (this.canConfirm()) {
      this.result = { 
        content: this.noteContent.trim()
      };
      this.close();
    }
  }

  override close(): Promise<any> {
    return super.close();
  }
}

